import { t } from 'i18next';

import { handleFailToast } from './handleToast';

export function showAuthErrorToast(error?: any) {
  error && console.error({ error });
  const isBlockedUser = error?.code === 'BLOCKED';
  if (isBlockedUser) handleFailToast(t('general.contact_customer_support_error_message'));
  else handleFailToast(t('general.contact_customer_support_error_message'));
}
